export const Icon = () => {
	return <svg viewBox="0 0 10 10" width="10" height="10" fill="#ffffff">
		<path d="M0 8.2375L1.76125 10L5 6.7625L8.23875 10L10 8.2375L6.7625 5L10 1.7625L8.2375 0L5 3.2375L1.7625 0L0 1.7625L3.2375 5L0 8.2375Z" />
		</svg>
}